// extracted by mini-css-extract-plugin
export default {"tag":"chat-type-icon_tag__iTWGJ"};